import React from 'react'

import SignalIntentCalculator from './SignalIntentCalculator'

const LoantermandDebtConsolidationCalculatorBlock = () => {
  return <SignalIntentCalculator Guid='72f6120a-ef2f-4979-be25-a30596187277' />
}

export default React.memo(LoantermandDebtConsolidationCalculatorBlock)
